export enum ActivityLogModule {
  WORK_ORDER = "WORK_ORDER",
  ENQUIRY = "ENQUIRY",
  QUOTATION = "QUOTATION",
  MATERIAL_REQUEST = "MATERIAL_REQUEST",
  PETTY_WORK = "PETTY_WORK",
  PURCHASE_ORDER = "PURCHASE_ORDER",
  PAYMENT = "PAYMENT",
  INVOICE = "INVOICE",
  AMC = "AMC",
  AMC_VISIT = "AMC_VISIT",
  ADVANCE = "ADVANCE",
  LEAVE_APPLICATION = "LEAVE_APPLICATION",
  PAYMENT_EXPECTATION = "PAYMENT_EXPECTATION",
  PAYROLL_RUN = "PAYROLL_RUN",
  SITE_VISIT = "SITE_VISIT",
  AUTH = "AUTH",
  CLIENT_ADVANCE = "CLIENT_ADVANCE",
  EMPLOYEE_ADVANCE = "EMPLOYEE_ADVANCE",
}

export interface ActivityLogActor {
  id: number;
  firstName: string;
  lastName: string;
  avatar?: string | null;
}

export interface ActivityLog {
  id: number;
  module: ActivityLogModule | string;
  sourceId: number | null;
  status: string | null;
  fromStatus: string | null;
  actorUserId: number | null;
  message: string | null;
  meta: Record<string, unknown> | null;
  created_at: string;
  actor: ActivityLogActor | null;
  source: Record<string, unknown> | null;
}

export interface ActivityLogParams {
  page?: number;
  limit?: number;
  module?: string;
  actorUserId?: number;
  fromDate?: string;
  toDate?: string;
}
